var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import User from '../model/User';
import serverLog from '../log/ServerLog';
import { AXIOS_HTTP_ERROR, TPLUS_HTTP_999, TPLUS_LOGIN_ERROR } from '../log/LogEventIds';
import UIConfirm from '../components/UIConfirm';
import bizError from '../bizError';
import _findIndex from 'lodash/findIndex';
import { stores } from 'mutants-microfx';
import { noErrorTips } from '../const/app';
import { Toast } from 'antd-mobile';
var QS = require('qs');
// import {env} from 'mutants-microfx';
// const {constant,platform,browser,os} = env;
var config = {
    proxy: {
        'throughProxy': false,
        'error': {
            "10101": "连接服务器超时",
            "10107": "T+服务器网络不给力，请确认T+云应用下云应用设置-服务器网络连接是否成功",
            "10104": "企业id不存在",
            "10106": "用户信息认证失败",
            "10108": "用户信息认证失败",
            "10109": "服务器内部错误",
            "T10108": "用户信息认证失败"
        }
    },
    cia: {
        'error': {
            '20109': '账号或密码错误',
            '20129': '账号或密码错误',
            '10002': '账号或密码错误',
            '20024': '密码输入错误次数超过10次，账号被锁定，请十五分钟之后再试！',
            '10001': '格式错误',
            '10004': '非空参数错误',
            '10005': 'JSON格式错误',
            '10006': 'appKey错误',
            '10007': 'appSecret错误',
            '20001': '注册来源不存在',
            '20119': '账号或密码错误',
            '20122': '用户昵称被占用',
            '20123': '用户不在组织内',
            '20203': '组织的账号被占用',
            '20204': '企业id不存在',
            '20231': '企业全称已存在',
            '20305': 'appKey没有访问权限',
            '20306': '应用不存在',
            '25015': '未授权的 客户端',
            '50000': '服务器内部异常',
            '20911': '友空间服务出现异常，正在紧急修复中，请稍后重试。'
        }
    },
    axios_error: {
        error_signs: ['timeout of '],
        error_tips: ['请求超时,请稍候再试!']
    },
    skip_error: [
        'chanjet.Authorization.Logout'
    ],
    login_method: [
        'chanjet.EAP.GZQ.CSP.GetTPlusToken',
        'chanjet.MB.MBPortal.GetPortalByAppid'
    ]
};
var errorShow = function (message, callback) {
    UIConfirm.show(message, function () {
        callback && callback();
    });
};
var reloginErrorCodes = ['EXSM0001', 'EXSM0002', 'EXSM0003', 'EXSM0004', 'EXSM0005'];
// const authReloginErrorCodes = ['EXERROR0001'];//没有权限
// else if(authReloginErrorCodes.some(reloginErrorCode=>{return reloginErrorCode===tplusErrorCode})){
//   errorShow(error.Message,()=>{
//     User.logout();
//   });
// }
var tplus999Handler = function (axios, err) {
    // 处理T+返回的异常
    var response = err.response;
    if (response.status === 999) {
        var error = response.data.Error;
        var tplusErrorCode_1 = error.Code;
        //上传阿里云日志  登录异常不记录
        var _a = err.config, requestData = _a.data, baseURL = _a.baseURL;
        var data = QS.parse(requestData);
        var apis_1 = JSON.parse(data.Apis);
        var methodName_1 = apis_1.Method;
        if (reloginErrorCodes.some(function (reloginErrorCode) { return reloginErrorCode === tplusErrorCode_1; })) {
            errorShow('登录信息异常，请保存当前操作数据后，重新进入应用!', function () {
                User.logout(null, false);
            });
        }
        else if ('Login1040' === tplusErrorCode_1) {
            errorShow('可用量正在整理，不能登录，请稍后再试！', function () {
                User.logout();
            });
        }
        else if ('EXSV0011' === tplusErrorCode_1) {
            //提供的服务名称不正确  将异常抛给前端的业务捕获
            console.error('error.Message======', error.Message);
        }
        else if (bizError.indexOf(tplusErrorCode_1) > -1) {
            //业务异常不做处理
        }
        else if (_findIndex(config.login_method, function (method) { return method === methodName_1; }) > -1) {
            var errorMsg = error && !!error.Message ? error.Message : '登录信息异常，请保存当前操作数据后，重新进入应用!';
            var eventId = TPLUS_LOGIN_ERROR;
            var logParam = { baseURL: baseURL, eventId: eventId, bodyData: JSON.stringify(data), errorMsg: errorMsg };
            serverLog(stores.logStore.logParam.logStore, logParam);
            errorShow(errorMsg, function () {
                if (apis_1.Args && apis_1.Args.NoLogout) {
                    return;
                }
                User.logout(null, false);
            });
        }
        else {
            if (stores.logStore.isUpload(baseURL)) {
                var bodyData = JSON.stringify(data);
                if (bodyData.length > 4096) {
                    if (data.Apis) {
                        bodyData = JSON.stringify({ Method: methodName_1, Body: bodyData.substr(0, 4096) });
                    }
                }
                var eventId = TPLUS_HTTP_999;
                var logParam = __assign({ baseURL: baseURL, eventId: eventId, bodyData: bodyData }, error);
                serverLog(stores.logStore.logParam.logStore, logParam);
            }
            errorShow(error.Message);
        }
    }
    else {
        Toast.info('当前网络不可用，请检查网络设置', 1);
    }
};
var ciaErrorHandler = function (axios, res) {
    var errorMsg = config.cia.error[res.errorCode];
    if (errorMsg) {
        errorShow("CIA\u63A5\u53E3\u8C03\u7528\u5F02\u5E38:" + errorMsg + ",ErrorCode:" + res.errorCode);
    }
    else {
        var errorMsg_1 = (typeof res == 'object' ? JSON.stringify(res) : res);
        errorShow("CIA\u63A5\u53E3\u8C03\u7528\u5F02\u5E38:\u8FD4\u56DE\u7ED3\u679C" + errorMsg_1 + ",ErrorCode:" + res.errorCode);
    }
};
var cloudProxyHandler = function (axios, res) {
    var errorMsg = config.proxy.error[res.code];
    var targetURL = window.localStorage.targetURL;
    var eventId = TPLUS_LOGIN_ERROR;
    var logParam = { targetURL: targetURL, eventId: eventId, bodyData: JSON.stringify(res), errorMsg: errorMsg };
    serverLog(stores.logStore.logParam.logStore, logParam);
    if (exitApp(res.code)) {
        return;
    }
    if (errorMsg) {
        errorShow(errorMsg);
    }
    else {
        errorShow('云代理接口调用异常:返回结果' + res);
    }
};
var exitApp = function (code, error) {
    var msg = config.proxy.error[code];
    if (msg) {
        if (error) {
            msg = error;
        }
        errorShow(msg, function () {
            //User.logout();
        });
        return true;
    }
    return false;
};
var middleware = function (axios) {
    axios.interceptors.response.use(function logResponse(res) {
        var isSkipService = config.skip_error.some(function (item) {
            return res.request.responseURL.indexOf(item) > -1;
        });
        if (isSkipService) {
            return res;
        }
        // console.log('%c Request Success:', 'color: #4CAF50; font-weight: bold', res);
        //setLoading(false);
        //处理CIA返回的异常  状态码是200
        if (res.data) {
            if (res.data.hasOwnProperty("errorCode")) {
                ciaErrorHandler(axios, res.data);
                return Promise.reject(res.data);
            }
            //处理云代理返回的异常
            if (res.data.hasOwnProperty("code") && res.config.baseURL.indexOf('cloudproxy01.chanapp.chanjet.com') > -1) {
                cloudProxyHandler(axios, res.data);
                return Promise.reject(res.data);
            }
        }
        return res;
    }, function logPromiseError(err) {
        // const isSkipService = config.skip_error.some((item)=>{
        //   return res.request.responseURL.indexOf(item) > -1;
        // });
        // if(isSkipService){
        //   return res;
        // }
        // console.log('%c Request Error:', 'color: #EC6060; font-weight: bold', err);
        //处理T+返回的异常
        if (err && err.response && err.response.status === 999) {
            if (err.response.data && err.response.data.Error && err.response.data.Error.Code) {
                if (exitApp(err.response.data.Error.Code, err.response.data.Error.Message)) {
                    return;
                }
            }
            tplus999Handler(axios, err);
            return Promise.reject(err.response.data.Error);
        }
        if (/Network Error/.test(err.toString())) {
            var baseURL_1 = err.config.baseURL;
            var cancelErrorTips = noErrorTips.some(function (noErrorTip) {
                return baseURL_1.indexOf(noErrorTip) > -1;
            });
            if (!cancelErrorTips) {
                Toast.info('网络繁忙，请稍后下拉刷新操作', 1);
            }
        }
        else {
            var errorMsg_2 = err.message;
            var _a = err.config, requestData = _a.data, baseURL_2 = _a.baseURL;
            //当请求参数为空时  也要上传相关日志 帮助分析是哪个接口调用异常
            var bodyData = '';
            if (stores.logStore.isUpload(baseURL_2)) {
                if (!!requestData) {
                    bodyData = JSON.stringify(QS.parse(requestData));
                }
                var eventId = AXIOS_HTTP_ERROR;
                var logParam = { baseURL: baseURL_2, eventId: eventId, bodyData: bodyData, errorMsg: errorMsg_2 };
                serverLog(stores.logStore.logParam.logStore, logParam);
            }
            //增加对getTplusToken接口的特殊处理，如果出现访问异常，提示用户进行检测
            try {
                if (!!requestData) {
                    var data = QS.parse(requestData);
                    var methodName_2 = JSON.parse(data.Apis).Method;
                    if (_findIndex(config.login_method, function (method) { return method === methodName_2; }) > -1) {
                        errorShow(config.proxy.error['10107'], function () {
                            //User.logout();
                        });
                        return;
                    }
                }
            }
            catch (err) {
                console.error('response-interceptor.logPromiseError=====', err);
            }
            //将请求框架的提示语转化成中文，方面客户理解
            var needReTip = _findIndex(config.axios_error.error_signs, function (sign) {
                return !!errorMsg_2 && errorMsg_2.indexOf(sign) > -1;
            });
            //是否需要弹出提示框 某些地方不需要提示出来  比如上传阿里云的错误
            var cancelErrorTips = noErrorTips.some(function (noErrorTip) {
                return baseURL_2.indexOf(noErrorTip) > -1;
            });
            if (!cancelErrorTips) {
                //解决部分外围接口报错  没有带请求参数  不影响到主体业务使用  就不显示错误提示框了  暂时先用requestData判断下
                //主要针对pos 偶发性弹出接口超时的提示  临时的解决方案  后续待改进
                if (!!requestData) {
                    if (needReTip > -1) {
                        errorShow(config.axios_error.error_tips[needReTip]);
                    }
                    else {
                        errorShow(errorMsg_2);
                    }
                }
            }
            return Promise.reject(err);
        }
    });
};
export default middleware;

//# sourceMappingURL=response-interceptor.js.map
